import store from '@/store';
import { parseDateTime } from '@/utils/dayjs';

export function monthOnlyFormat(date) {
  return parseDateTime('MMM YYYY', date);
}

export function dateOnlyFormat(date) {
  const dateFormat =
    store.getters['Auth/activeRoleDateFormat'] ?? 'DD MMM YYYY';
  return parseDateTime(dateFormat, date);
}

export function dateTimeFormat(date) {
  const dateTimeFormat =
    store.getters['Auth/activeRoleDateTimeFormat'] ?? 'DD/MM/YYYY hh:mm A';
  return parseDateTime(dateTimeFormat, date);
}
